import ErrorWithCause from '@helpers/ErrorWithCause';
import axios from 'axios';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
const updateUserFirebaseState = async () => {
    try {
        const response = await axios.post(`${SYMFONY_API_BASE_URL}/api/user/v1/sync-firebase-state`);
        return response.data;
    }
    catch (error) {
        throw new ErrorWithCause(error);
    }
};
export default updateUserFirebaseState;
